import {HTMLAttributes} from 'react'
import {
    StyledSidebarWrapper,
    StyledSidebarBody,
    StyledSidebarHeader,
    StyledSidebarButton,
    StyledSidebarSlot,
    StyledSidebarNavGroupTitle,
    StyledSidebarSeparator,
    StyledSidebarButtonsGroup,
    StyledSidebarButtonLink,
    StyledSidebarButtonNavLink
} from './style'
import {Flexbox, FlexboxProps} from '@/components/ui/flexbox/FlexBox'
import {ButtonProps} from '@/components/ui/button/Button'
import {ButtonLinkProps} from '../button-link/ButtonLink'
import {ButtonNavLinkProps} from '../button-nav-link/ButtonNavLink'

export const SidebarWrapper = (props: HTMLAttributes<HTMLDivElement>) => <StyledSidebarWrapper {...props} />
export const SidebarHeader = (props: HTMLAttributes<HTMLDivElement>) => <StyledSidebarHeader {...props} />
export const SidebarTitleBar = ({children, ...props}: FlexboxProps<'div'>) => <Flexbox children={children} {...props} />
export const SidebarBody = (props: HTMLAttributes<HTMLDivElement>) => <StyledSidebarBody {...props} />
export const SidebarSlot = (props: FlexboxProps<'div'> & {$fullHeight?: boolean}) => <StyledSidebarSlot {...props} />
export const SidebarNavGroupTitle = (props: HTMLAttributes<HTMLSpanElement>) => (
    <StyledSidebarNavGroupTitle {...props} />
)
export const SidebarSeparator = (props: HTMLAttributes<HTMLDivElement>) => <StyledSidebarSeparator {...props} />
export const SidebarButtonsGroup = (props: HTMLAttributes<HTMLDivElement>) => <StyledSidebarButtonsGroup {...props} />

export const SidebarButton = ({
    variant,
    ...props
}: Omit<ButtonProps, 'variant'> & {variant?: 'ghost' | 'secondary'}) => (
    <StyledSidebarButton {...props} variant={variant ?? 'ghost'} />
)
export const SidebarButtonNavLink = (props: Omit<ButtonNavLinkProps, 'variant'>) => (
    <StyledSidebarButtonNavLink {...props} variant="ghost" />
)
export const SidebarButtonLink = (props: Omit<ButtonLinkProps, 'variant'>) => (
    <StyledSidebarButtonLink {...props} variant="ghost" />
)
